export default {"src":"/_next/static/media/search.813cc08a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};